var formValidation = require('../components/formValidation');
var createErrorNotification = require('../components/errorNotification');
var geolocationHelper = require('../geolocation/geolocationHelper');
var otpVerification = require('../components/otpVerification');

var location = window.location;
let locationCookie = geolocationHelper.getCookie('dataUserObtenerMunicipios');

var otploginAction = "register"
var pendingRedirectUrl = null
var emailVerifiedInput = $("#is-email-verified-input");

$('.login-modal-cancel').on('click', function (e) {
    let isCheckout = $(".page").hasClass('checkout-page');
    if (isCheckout) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.location.href = $(this).data('home-url');
    }
});

window.addEventListener('beforeunload', (event) => {
    if (window.location.pathname.includes('/login') && !sessionStorage.getItem('loginInProgress')) {
        localStorage.removeItem('favoritePid');
        localStorage.removeItem('addToWishlist');
    }
});

var lockedLogin = true;
var loginType = '';
$('.btn-continue-login').on('click', function (e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    $('#caducatedSession').modal('hide');
    $.ajax({
        url: $("#modalLoginToken").val(),
        type: 'get',
        data: { targetLocation: window.location.href },
        success: function (data) {
            $('#csrfData').val(data.csrfData.token);
            $('#csrfData').attr('name', data.csrfData.tokenName);
            $('#loginModal').modal('show');
        }
    });
    $('input#login-form-password').val('');
    var sessionType = $('input#login-form-email').attr('session-type');
    // Based on the session type, set the last login legend
    let lastLoginLegendText = $('.last-login-legend').data('login-legend-text');
    let lastLoginLegendAccount = $('.last-login-legend').data('login-legend-account');
    if (sessionType.toLowerCase() === 'google') {
        $('input#login-form-email').val('');
        $('.last-login-legend').html(lastLoginLegendText + ' <strong>' + lastLoginLegendAccount + ' ' + sessionType + '</strong>');
    } else if (sessionType.toLowerCase() === 'facebook') {
        $('input#login-form-email').val('');
        $('.last-login-legend').html(lastLoginLegendText + ' <strong>' + lastLoginLegendAccount + ' ' + sessionType + '</strong>');
    } else {
        let emailLegend = $('.last-login-legend').data('email-legend');
        $('.last-login-legend').html(lastLoginLegendText + ' <strong>' + lastLoginLegendAccount + ' ' + emailLegend.toLowerCase() + '</strong>');
    }
});

$(".social-login-button").on('click', function (e) {
    // Save favoritePid in localStorage to add to wishlist after social login
    const favoritePid = localStorage.getItem('favoritePid');
    if (favoritePid) {
        localStorage.setItem('addToWishlist', favoritePid);
        localStorage.removeItem('favoritePid');
    }
    $.ajax({
        url: $("#setTargetLocation").val(),
        type: 'get',
        data: { targetLocation: window.location.href }
    });
    var email = $('form.login').find('input#login-form-email').data('email');
    if (email) {
        sessionStorage.setItem('lastLoginEmail', email);
    }
    var sessionType = $('input#login-form-email').attr('session-type');
    if (sessionType){
        sessionType = sessionType.toLowerCase();
        if (sessionType !== 'google' && sessionType !== 'facebook' && lockedLogin) {
            loginType = 'social';
            $('#modalConfirmLogin').modal('show');
            $('#loginModal').addClass('item-brightness');
            $('.btn-confirm-switch-account').data('href', $(this).data('href'));
            sessionStorage.removeItem('lastLoginEmail');
            return;
        }
    }
    window.location.href = $(this).data('href');
});
$('.btn-confirm-switch-account').on('click', function (e) {
    e.preventDefault();
    $('#modalConfirmLogin').modal('hide');
    $('#loginModal').removeClass('item-brightness');
    lockedLogin = false;
    if (loginType === 'social') {
        window.location.href = $(this).data('href');
    } else {
        $('form.login').submit();
    }
});

$('.btn-cancel-switch-account').on('click', function (e) {
    $('#loginModal').removeClass('item-brightness');
});

var lastLoginEmail = sessionStorage.getItem('lastLoginEmail');
var currentEmail = $('form.login').find('input#login-form-email').data('email');
var sessionType = $('input#login-form-email').attr('session-type');
// Only apply for social login, if the last login email is different from the current email
if (lastLoginEmail && lastLoginEmail !== currentEmail && (sessionType.toLowerCase() === 'google' || sessionType.toLowerCase() === 'facebook')) {
    $('#modalConfirmLogin').modal('show');
    // Replace btn-cancel-switch-account event with new logic
    $('.btn-cancel-switch-account').off('click');
    $('.btn-cancel-switch-account').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var logoutButton = $('#logout-button').attr('href');
        window.location.href = logoutButton;
    });

    $('.btn-confirm-switch-account').off('click');
    $('.btn-confirm-switch-account').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('#modalConfirmLogin').modal('hide');
        $('#loginModal').removeClass('item-brightness');
    });
}
sessionStorage.removeItem('lastLoginEmail');

module.exports = {
    login: function () {
        $('form.login').submit(function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            var form = $(this);
            const isModalLogin = form.data('modal-login');
            var formData = form.serializeArray();
            
            sessionType = form.find('input#login-form-email').attr('session-type');
            var email = form.find('input#login-form-email').data('email');
            if (sessionType){
                sessionType = sessionType.toLowerCase();
                if ((sessionType === 'google' || sessionType === 'facebook') && lockedLogin) {
                    $('#modalConfirmLogin').modal('show');
                    $('#loginModal').addClass('item-brightness');
                    loginType = 'email';
                    return;
                }
            }
            // If the email is different from the current email and the login is locked, show modal confirm login
            if (email && email !== form.find('input#login-form-email').val() && lockedLogin) {
                $('#modalConfirmLogin').modal('show');
                $('#loginModal').addClass('item-brightness');
                return;
            }
            
            if (locationCookie.length >= 0 || locationCookie) {
                formData.push({name: "locationCookie", value: locationCookie});
            }
            var url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success: function (data) {
                    form.spinner().stop();
                    if (data.searchImpressionData) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(JSON.parse(data.searchImpressionData));
                    }
                    if (!data.success) {
                        if (data.resetPassword) {
                            $("#migratedUser").modal("show");
                        } else {
                            formValidation(form, data);
                            $('form.login').trigger('login:error', data);   
                        }
                    } else {
                        const favoritePid = localStorage.getItem('favoritePid');
                        if (favoritePid) {
                            localStorage.setItem('addToWishlist', favoritePid);
                            localStorage.removeItem('favoritePid');
                        }
                        $('form.login').trigger('login:success', data);
                        if (isModalLogin) {
                            window.location.reload();
                            return;
                        }
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data && data.responseJSON && data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
        });
    },
    register: function () {
        this.initOtpEvents();

        $('form.registration').submit(function (e) {
            var form = $(this);
            e.preventDefault();

            var emailInput = $("#registration-form-email").val();
            var verifiedEmail = emailVerifiedInput.length > 0 ? emailVerifiedInput.val() === "true" : true;
            var urlOtp = emailVerifiedInput.length > 0  ? emailVerifiedInput.data("request-otp-url") : "";
            otploginAction = "register";

            var formData = form.serializeArray();

            var acceptAdvertising = $("#acceptAdvertising").is(':checked');
            formData.push({name: "acceptAdvertising", value: acceptAdvertising ? 1 : 0});

            var customerType = $("#registration-form-customertype").val();
            if (customerType) {
                formData.push({name: "customerType", value: customerType});
            }

            if (locationCookie.length >= 0 || locationCookie) {
                formData.push({name: "locationCookie", value: locationCookie});
            }
            e.preventDefault();

            if (!verifiedEmail && emailVerifiedInput.length > 0) {
                var validateUrl = emailVerifiedInput.data("verify-registration-url");
                form.spinner().start();

                $.ajax({
                    url: validateUrl,
                    type: 'post',
                    dataType: 'json',
                    data: formData,
                    success: function (data) {
                        form.spinner().stop();

                        if (!data.success) {
                            $('form.registration').trigger('login:register:error', data);
                            formValidation(form, data);

                            if (data.errorCaptcha) {
                                let errorModal = $("#errorCaptcha");
                                if (!errorModal.length) {
                                    $('body').append(data.errorModalHtml);
                                    errorModal = $("#errorCaptcha");
                                }
                                errorModal.modal('show');
                                if (window.turnstile) window.turnstile.reset();
                            } else if (data.enableCaptcha) {
                                if (window.turnstile) window.turnstile.reset();
                            }
                        } else {
                            otpVerification.openModal(emailInput, urlOtp, otploginAction);
                        }
                    },
                    error: function (err) {
                        form.spinner().stop();
                        var errorMsg = (err.responseJSON && err.responseJSON.errorMessage) 
                            ? err.responseJSON.errorMessage 
                            : 'Error al validar la información.';
                        createErrorNotification($('.error-messaging'), errorMsg);
                    }
                });

                return false;
            }

            var url = form.attr('action');
            form.spinner().start();
            $('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('form.registration').trigger('login:register:error', data);
                        formValidation(form, data);
                        if (data.errorCaptcha) {
                            let errorModal = $("#errorCaptcha");
                            if (!errorModal.length) {
                                $('body').append(data.errorModalHtml);
                                errorModal = $("#errorCaptcha");
                            }
                            errorModal.modal('show');
                            window.turnstile.reset(); 
                        } else if (data.enableCaptcha) {
                            window.turnstile.reset(); 
                        }                                               
                    } else {
                        $('form.registration').trigger('login:register:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    form.spinner().stop();
                }
            });
            return false;
        });
    },
    selectLoginForm: function () {
        $('#select-login').on('click', function (e) {
            let metaTitle = $(this).data('meta-title');
            if (metaTitle) {
                document.title = metaTitle;
            }
            e.preventDefault();
            if (!$(".reset-pass-content").hasClass("d-none")) {
                $(".reset-pass-content").addClass("d-none")
            }

            $('.login-form-section').addClass('d-none');
            $('.register-form-section').removeClass('d-none');
            $('#login').removeClass('d-none').addClass('active');
            $('#register').removeClass('active').addClass('d-none');
        });
    },
    selectRegisterForm: function () {
        $('#select-register').on('click', function (e) {
            e.preventDefault();
            let metaTitle = $(this).data('meta-title');
            if (metaTitle) {
                document.title = metaTitle;
            }
            $(".registration input:not([type=hidden])").val('');
            if (!$(".reset-pass-content").hasClass("d-none")) {
                $(".reset-pass-content").addClass("d-none")
            }

            $('.login-form-section').removeClass('d-none');
            $('.register-form-section').addClass('d-none');
            $('#login').addClass('d-none').removeClass('active');
            $('#register').removeClass('d-none').addClass('active');

        });
    },
    openResetPasswordForm: function () {
        $('#password-reset').on('click', function (e) {
            e.preventDefault();
            $('.reset-pass-content').removeClass('d-none');
            $('#login').addClass('d-none').removeClass('active');
        });
    },
    closeResetPasswordForm: function () {
        $('.back-login-form').on('click', function (e) {
            e.preventDefault();
            $('.reset-pass-content').addClass('d-none');
            $('#login').removeClass('d-none').addClass('active');
        });
    },
    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $('.reset-password-form').trigger('login:register', e);
            $('.reset-password-form').find('.invalid-feedback').remove();
            otploginAction = "resetPassword"
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        formValidation(form, data);
                        if (!data.isVerifiedEmail) {
                            var urlOtp = $("#is-email-verified-input").data("request-otp-url");
                            otpVerification.openModal(data.email, urlOtp, otploginAction);
                        }
                        if (data && data.fields && data.fields.errorType === 'emailNotFound') {
                            $('#reset-password-email').addClass('is-invalid');
                            $('#reset-password-email').after('<div class="invalid-feedback">' + data.fields.errorMsg + '</div>');
                        }
                    } else if (data.success) {
                        if (!data.mobile) {
                            $('.reset-pass-content').addClass('d-none');
                            $('#login').removeClass('d-none').addClass('active');
                        }
                        if ($('#loginModal').length) {
                            $('#loginModal').modal('hide');
                        }
                        $("#resetPasswordEmail").modal('show');
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });

        $('.js_reset-migrated-password').on('click', function (e) {
            var form = $("form.login");
            e.preventDefault();
            var url = $(this).attr('href');
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {                
                    $("#migratedUser").modal("hide");
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });

        $('.change-password-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        $("#successResetPassword").modal('show');
                    }
                },
                error: function () {
                    $form.spinner().stop();
                }
            });
            return false;
        })
    },
    confirmPassFields: function () {
        $('#registration-form-password').on('blur', function (e) {
            let passwordValue = $(this).val();
            // check if password is valid
            const r = /^(?=.*\d)[A-Za-z0-9_]{12,255}$/;
            let validPassword = r.test(passwordValue);
            if (!validPassword) {
                $(this).addClass('is-invalid');
                let errorMsg = "La contraseña debe cumplir con los siguientes requisitos: <br><br><ul>";

                // check if password has at least 12 characters
                if (passwordValue.length < 12) {
                    errorMsg += "<li>Debe contener al menos 12 caracteres.</li>";
                }
                // check if password has at least 1 uppercase letter
                let checkUppercase = /[A-Z]/.test(passwordValue);
                if (!checkUppercase) {
                    errorMsg += "<li>Debe contener al menos 1 letra mayúscula.</li>";
                }
                // check if password has at least 1 number
                let checkNumber = /[0-9]/.test(passwordValue);
                if (!checkNumber) {
                    errorMsg += "<li>Debe contener al menos 1 número.</li>";
                }

                let checkSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(passwordValue);
                let checkSpecialLetter = /[ñáéíóúü]/i.test(passwordValue);
                if (checkSpecialChar || checkSpecialLetter) {
                    errorMsg += "<li>No se permiten caracteres especiales.</li>";
                }

                errorMsg += "</ul>";
                $(this).parents('.form-group').find('.invalid-feedback').html(errorMsg).removeClass('message-color');
            } else {
                $(this).removeClass('is-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').text('');
            }
            // check if password confirmation is the same as password
            let passwordConfirm = $("#registration-form-password-confirm");
            if (passwordConfirm.val() !== passwordValue && passwordConfirm.val() !== '') {
                passwordConfirm.addClass('is-invalid');
                passwordConfirm.parents('.form-group').find('.invalid-feedback').text("Las contraseñas no coinciden").removeClass('message-color');
            } else {
                passwordConfirm.removeClass('is-invalid');
            }
        });

        $('#registration-form-password-confirm').on('blur', function (e) {
            e.preventDefault();
            var password = $("#registration-form-password").val();

            if (password && this.value !== password) {
                this.setCustomValidity($(this).data('coincidence-error'));
                if (!this.validity.valid) {
                    $(this).addClass('is-invalid');
                    var validationMessage = $(this).data('coincidence-error');
                    $(this).parents('.form-group').find('.invalid-feedback').text(validationMessage);
                }
            } else {
                $(this).removeClass('is-invalid');
            }
        });

        $(".registration button").on('click', function (e) {
            var passwordValue = $("#registration-form-password").val();
            var passwordConfirm = document.getElementById("registration-form-password-confirm");
            var password = document.getElementById("registration-form-password");
            var emailValue = $("#registration-form-email").val();
            var nameInput = document.getElementById("registration-form-fname");
            var lnameInput = document.getElementById("registration-form-lname");
            var email = document.getElementById("registration-form-email");
            var phoneValue = document.getElementById("registration-form-phone");
            var regexEmail = /^[\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,4}$/;
            var locationInSession= $(".location-in-session").val();;
            var validationMessage;
            var mensajeErrorGTM= false;
            if (passwordValue && passwordConfirm.value !== passwordValue) {
                passwordConfirm.setCustomValidity($(passwordConfirm).data('coincidence-error'));
                if (!passwordConfirm.validity.valid) {
                    $(passwordConfirm).addClass('is-invalid');
                    validationMessage = $(passwordConfirm).data('coincidence-error');
                    mensajeErrorGTM= validationMessage;
                    $(passwordConfirm).parents('.form-group').find('.invalid-feedback').text(validationMessage);
                }
            } else {
                $(this).removeClass('is-invalid');
            }

            if (!password.validity.valid) {
                $(".registration #form-password-error").removeClass("message-color");
            } else {
                $(".registration #form-password-error").addClass("message-color");
            }
            
            if (!regexEmail.test(emailValue)) {
                $(email).addClass('is-invalid');
                validationMessage = $(email).data("pattern-mismatch");
                $(email).parents('.form-group').find('.invalid-feedback').text(validationMessage);
                if (mensajeErrorGTM) {
                    mensajeErrorGTM = validationMessage + " , " + mensajeErrorGTM;
                } else {
                    mensajeErrorGTM = validationMessage;
                } 
            } else {
                $(email).removeClass('is-invalid');
            }
            
            if (!phoneValue.validity.valid) {
                var missingError = phoneValue.getAttribute('data-pattern-mismatch');
                if (mensajeErrorGTM) {
                    mensajeErrorGTM = missingError + " , " + mensajeErrorGTM;
                } else {
                    mensajeErrorGTM = missingError;
                }        
            }

            if(!nameInput.validity.valid || !lnameInput.validity.valid || !password.validity.valid) {
                var messageError= "Campos requeridos";
                if (mensajeErrorGTM) {
                    mensajeErrorGTM = messageError + " , " + mensajeErrorGTM;
                } else {
                    mensajeErrorGTM = messageError;
                }      
            }
            if (mensajeErrorGTM) {
                window.dataLayer.push({
                    'event': 'sign_up_error',
                    'customer_id': "",
                    'customer_group': locationInSession,
                    'method' : "Traditional",
                    'sign_up_errors': mensajeErrorGTM
                });
            }
        });

        $(".change-password-form button").on("click", function (e) {
            var newPassword = document.getElementById("newPassword");
            var newPasswordConfirm = document.getElementById("newPasswordConfirm");
            var validationMessage;

            if (newPassword && newPasswordConfirm.value !== newPassword.value) {
                newPasswordConfirm.setCustomValidity($(newPasswordConfirm).data('coincidence-error'));
                if (!newPasswordConfirm.validity.valid) {
                    $(newPasswordConfirm).addClass('is-invalid');
                    validationMessage = $(newPasswordConfirm).data('coincidence-error');
                    $(newPasswordConfirm).parents('.form-group').find('.invalid-feedback').text(validationMessage);
                }
            } else {
                $(this).removeClass('is-invalid');
            }

            if (!newPassword.validity.valid) {
                $(".change-password-form #form-password-error").removeClass("message-color");
            } else {
                $(".change-password-form #form-password-error").addClass("message-color");
            }
        });

    },
    confirmEmailField: function () {
        $('#registration-form-email').on('blur', function (e) {
            e.preventDefault();
            $("#registration-form-email-confirm").val($(this).val());
        });
    },
    filterInputText: function () {
        $(".registration input[type='text']:not(.search-field)").on('keypress', function (e) {
            e.preventDefault();
            var textInput = $(this).val();            
            var regexp = /^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]$/;
            if(regexp.test(e.key)) {
                $(this).val(textInput + e.key);
            }
        });
    },
    filterInputTel: function () {
        $("input[type='tel']").on('input', function (e) {
            e.preventDefault();
            this.value = this.value.replace(/[^0-9]/g,'');
        });
    },
    passwordToggle: function () {
        // toggle password visibility
        $('.password-toggle-btn').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            var allPasswordInputs = $('#registration-form-password, #registration-form-password-confirm');
            var allToggleButtons = $('.password-toggle-btn');
            var allEyeIcons = allToggleButtons.find('.eye-icon-show, .eye-icon-close');
            
            var currentPasswordInputType = $('#registration-form-password').attr('type');
            if (currentPasswordInputType === 'password') {
                allPasswordInputs.attr('type', 'text');
                allEyeIcons.removeClass('eye-icon').addClass('eye-icon-close');
            } else {
                allPasswordInputs.attr('type', 'password');
                allEyeIcons.removeClass('eye-icon-close').addClass('eye-icon');
            }
        });
    },
    removeInvalidFeedback: function () {
        // remove invalid feedback when user types anything
        $('.registration input').on('keyup', function () {
            if ($(this).val() !== '') {
                $(this).siblings('.invalid-feedback').text('');
                $(this).parents('.form-group').removeClass('is-invalid');
            }
        });
    },
    checkFormInputsOnBlur: function () {
        // validate other inputs
        $('#registration-form-fname, #registration-form-lname').on('blur', function () {
            if ($(this).val() === '') {
                $(this).addClass('is-invalid');
                let errorMsg = $(this).data("missing-error");
                $(this).parents('.form-group').find('.invalid-feedback').text(errorMsg);
            } else {
                $(this).removeClass('is-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').text('');
            }
        });
        // validate email
        $('#registration-form-email').on('blur', function () {
            if ($(this).val() === '') {
                let errorMsg = $(this).data("missing-error");
                $(this).parents('.form-group').find('.invalid-feedback').text(errorMsg);
                return;
            }
            if (!$(this).val().match(/^[\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,4}$/)) {
                $(this).addClass('is-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').text('El email no es válido');
            } else {
                $(this).removeClass('is-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').text('');
            }
        });
        // validate phone
        $('#registration-form-phone').on('blur', function () {
            if (!$(this).val().match(/^[0-9]{10}$/)) {
                $(this).addClass('is-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').text('El teléfono no es válido');
            } else {
                $(this).removeClass('is-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').text('');
            }
        });
    },
    initOtpEvents: function () {
        otpVerification.init();

        $('body').off('email:otpVerified.login').on('email:otpVerified.login', function (e, data) {
            var otpFlow = $('#otp-verified-flow').val();

            if (otpFlow === "register") {
                $("#is-email-verified-input").val("true");
                $('form.registration').trigger('submit');
            } else if (otpFlow === "resetPassword") {
                $("#is-email-verified-input").val("true");
                $('form.reset-password-form').trigger('submit');
            }
        });
    },
};